<template>
  <div class="page-settings">
    <Currencies />
    <CategoriesTable />
    <company-info />
  </div>
</template>

<script>
import CategoriesTable from './components/categoriesTable'
import Currencies from './Currencies/Index'
import companyInfo from './companyInfo/Index'

export default {
  name: 'PageSettings',
  components: {
    CategoriesTable,
    Currencies,
    companyInfo,
  },
}
</script>

<style scoped lang="scss">
.page-settings {

}
</style>
